import { useState } from "react";
import { authServices } from "Utils/auth/services";
import emitter from "Utils/emitter";

const useUserBalance = (user_id: string | null, fullExp: boolean) => {
  const [balance, setBalance] = useState(0);
  const [exp, setExp] = useState<number>(0);
  const [expShear, setExpShear] = useState<number>(0);

  const fetchBalance = async () => {
    if (!user_id) return;
    try {
      const { response } = await authServices.showBalance({
        userid: user_id,
        full_exposure: fullExp,
      });
      setBalance(response.data.balance);
      setExp(response.data.liability);
      setExpShear(response.data.liability_share);

      emitter.emit("balanceUpdated", {
        balance: response.data.balance,
        liability: response.data.liability,
        liability_share: response.data.liability_share,
      });
    } catch (err) {
      console.error("Error fetching balance data:", err);
    }
  };

  return { balance, exp, fetchBalance, expShear };
};

export default useUserBalance;
